module.exports = __webpack_public_path__ + "assets/woocommerce.3251dc4f.svg";